export const SOAPBLOX_FEE = 10000;
export const SOAPBLOX_PER_PAGE = 20;
export const SOAPBLOX_WALLET =
  "BLX6EVHVPTLJ64CQ3VO3BKCAX4KPX53DPXMSNKDUOW4IQK2DHSD7OEIFOY";
export const SOAPBLOX_DISCORD = "https://discord.gg/ndv5cnxU";
export const SOAPBLOX_TWITTER = "https://twitter.com/soapblox_";
